import { useState } from 'react';

import Button from 'carbon-react/lib/components/button';

import Translate from '../../components/Translate/Translate';

const SuccessScreen = ({ email, resendEmail, returnToSignUp }) => {
  const [disabled, setDisabled] = useState(false);

  const resend = () => {
    resendEmail();
    setDisabled(true);
  };

  return (
    <div className="success">
      <div className="card">
        <div className="title">
          <Translate scope="auth.CheckYourEmail" />
        </div>
        <p className="paragraph">
          <Translate scope="auth.Wevesentanemailto" />
          <strong>{`${email}.`}</strong>
          <Translate scope="auth.Openitupand" />
        </p>
        <p className="paragraph">
          <Translate scope="auth.CantfindthatemailRegister" options={{ email }} markdown />
        </p>
        <Button buttonType="primary" className="return-button" onClick={returnToSignUp}>
          <Translate scope="auth.ReturntoSignUp" />
        </Button>
        <Button buttonType="secondary" className="return-button" disabled={disabled} onClick={resend} ml={1}>
          <Translate scope="auth.ResendEmail" />
        </Button>
      </div>
    </div>
  );
};

export default SuccessScreen;
